import {
  Menu as BlueprintMenu,
  MenuProps as BlueprintMenuProps,
} from '@blueprintjs/core';
import classNames from 'classnames';
import * as React from 'react';

export type MenuItemsProps = Omit<BlueprintMenuProps, 'large'> & {
  'data-testid'?: never;
  testId?: string;
};

export const MenuItems: React.VFC<MenuItemsProps> = ({
  children,
  className,
  testId,
  ...props
}) => (
  <BlueprintMenu
    className={classNames(className, 'vb-menu-items')}
    data-testid={testId}
    // eslint-disable-next-line react/jsx-props-no-spreading
    {...props}
  >
    {children}
  </BlueprintMenu>
);
